import {Injectable}         from '@angular/core';
import {HttpService}        from '../http.service';
import { FillLevels }       from "../../../shared-gen/Model/Selections/FillLevels";

/**
 * Functions to control the vending machine, like a coffee machine
 * or a Warenautomat.
 */
@Injectable({
	providedIn: 'root'
})
export class MachineApi extends HttpService {

	/**
	 * Brings the held back product (if any) back to the customer.
	 *
	 * This happens when the machine required the user to take the served product,
	 * but he didn't do it. Then the machine may take it back and goes into
	 * [ServingState.Holding]. In this state, this method brings
	 * the product back again to the customer.
	 */
	async bringBack(): Promise<void> {
		return await this.post<void>('machine/bringback');
	}

	/**
	 * Sets all selections to refilled, i.e. to their original capacity.
	 */
	async refilled(): Promise<void> {
		return await this.post<void>('machine/refilled');
	}

	/**
	 * Tells the machine that a served product was removed now.
	 * Currently only supported for the emulator machine.
	 */
	async removed(): Promise<void> {
		return await this.post<void>('machine/removed');
	}

	/**
	 * Sets the new fillLevel on the machine
	 * @param fillLevels
	 */
	async setFillLevels(fillLevels: FillLevels): Promise<void> {
		return await this.post<void>('machine/filllevels', fillLevels);
	}

	/**
	 * Sets (true) or deletes (false) the problem with the given ID from/to the SandenVendo VM.
	 */
	async setProblem(problemID: string, enabled: boolean): Promise<void> {
		return await this.post<void>(`sandenvendo/problems?problemID=${problemID}&enabled=${enabled}`);
	}
}
